import {  Tabs, Badge } from 'antd'
import React, { useState } from 'react'
import IncomeListAdd from './IncomeListAdd'             
import Main from '../../cpn/Main';
import { PlusOutlined, ClockCircleOutlined, ScheduleOutlined, AuditOutlined, FileDoneOutlined, FileSearchOutlined } from '@ant-design/icons';
import IncomeListPendding from './IncomeListPendding';  
import IncomeListSubmitted from './IncomeListSubmitted';                
import IncomeListNeedApprove from './IncomeListNeedApprove';
import IncomeListApproved from './IncomeListApproved';
import IncomeListNeedRead from './IncomeListNeedRead';
import IncomeListAll from './IncomeListAll';
function IncomeList(props) {
    const qy_id = props.qy_id;
    const qy_name = props.qy_name;
    const yh_id = props.yh_id;
    const yh_name = props.yh_name;
    const yh_qx = props.yh_qx || '';  
    const [list,setList] = React.useState(props.ddsrList);
    React.useEffect(() => {
        if (props.ddsrList.length > 0) {
            const formattedData = props.ddsrList.map((item,index) => ({
                key: item.ddsr_id,
                ddsr_content: item.ddsr_content,
                ddsr_ctime: item.ddsr_ctime,
                ddsr_price: item.ddsr_price,
                ddsr_uname: item.ddsr_uname,
                ddsr_num: item.ddsr_num,                  
                ddsr_uid: item.ddsr_uid,   
                ddsr_type_name: item.ddsr_type_name,               
                ddsr_kh_name: item.ddsr_kh_name,               
                ddsr_amount: item.ddsr_amount,               
                ddsr_bzd_danhao:item.ddsr_bzd_danhao,
                ddsr_bzd_id:item.ddsr_bzd_id,
                ddsr_date:item.ddsr_date,
                ddsr_date_end:item.ddsr_date_end,
                ddsr_bzd_name:item.ddsr_bzd_name,
                ddsr_type_id:item.ddsr_type_id,
                ddsr_kh_id:item.ddsr_kh_id,
                ddsr_state:item.ddsr_state,
                ddsr_bm_id:item.ddsr_bm_id,
                ddsr_bm_name:item.ddsr_bm_name,
                ddsr_khyhzh_id:item.ddsr_khyhzh_id,
                ddsr_khyhzh_name:item.ddsr_khyhzh_name,
                ddsr_image_name:item.ddsr_image_name,
                ddsr_image_file:item.ddsr_image_file,
                ddsr_name:item.ddsr_name,
                ddsr_state_time:item.ddsr_state_time,
            }));
            const sortedData = formattedData.sort((a, b) => new Date(a.dsbzdsz_ctime) - new Date(b.dsbzdsz_ctime));
            setList(sortedData);
            
        }else{
            setList([])
        }}, [props.ddsrList])
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_income_active_key') || '1');
    return (
        <Main 
            selectedKeys={['/IncomeList']}
            qy_id={props.qy_id}
            qy_name={props.qy_name}
            yh_id={props.yh_id}
            yh_name={props.yh_name}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            reportEndNeedReadNum={props.reportEndNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
            yh_qx={props.yh_qx}
        >                            
            <Tabs
                activeKey={activeKey} 
                onChange={(key) => {    
                    setActiveKey(key)
                    localStorage.setItem('jtg-caiwu_income_active_key', key)
                }}
                items={[
                    {
                        key: '0',
                        label: '新增',
                        children: <IncomeListAdd qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <PlusOutlined />,
                    },
                    {
                        key: '1',
                        label: '我未提交的',
                        children: <IncomeListPendding qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <ClockCircleOutlined />,
                    },
                    {
                        key: '2',
                        label: <span>我已提交的<Badge count={Number(props.ddsrRejectedNum) + Number(props.ddsrEndNeedReadNum)}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <IncomeListSubmitted qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} ddsrRejectedNum={props.ddsrRejectedNum} ddsrEndNeedReadNum={props.ddsrEndNeedReadNum} yh_qx={yh_qx}/>,
                        icon: <ScheduleOutlined />,
                    },
                    {
                        key: '3',
                        label: <span>需要我审批的<Badge count={props.ddsrNeedApproveNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <IncomeListNeedApprove qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.ddsrSpList} yh_qx={yh_qx}/>,
                        icon: <AuditOutlined />,
                    },
                    {
                        key: '4',
                        label: '我已审批的',
                        children: <IncomeListApproved qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.ddsrSpList} yh_qx={yh_qx}/>,
                        icon: <FileDoneOutlined />,
                    },
                    {
                        key: '5',
                        label: <span>抄送给我的<Badge count={props.ddsrNeedReadNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <IncomeListNeedRead qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.ddsrSpList} yh_qx={yh_qx}/>,
                        icon: <FileDoneOutlined />,
                    },
                    ...(yh_qx.includes('管理') ? [{
                        key: '6',
                        label: '全部单据',
                        children: <IncomeListAll qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <FileSearchOutlined />,
                    }] : []),
                ]}
            />
        </Main>
    )
}

export default IncomeList